import css from 'styled-jsx/css';
import { rgba } from 'common/styling/theme';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .PaymentsSuccess {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    justify-content: center;
    position: relative;
    gap: 24px;
    border: 1px solid #b1b0b0;
    border-radius: 16px;
    padding: 24px 32px;

    &-icon {
      display: flex;
      border-radius: 50%;
      height: fit-content;
      flex-shrink: 0;
      flex-grow: 0;
    }

    h3 {
      font-size: 24px;
      text-align: center;
    }

    p {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.5);
      text-align: center;
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .PaymentsSuccess {
      &-icon {
        box-shadow: 0 0 0 5px ${colors.white.hex}, 0 0 0 10px ${rgba([colors.success.rgb, 0.2])};
        rect {
          fill: ${colors.success.hex};
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
